
import apiCall from "../axios/apiCall";
const controller = "roles";

export default {
  getRoles: async () => {
    let response = { success: true };
    const method = ``;
    try {
      const apiResponse = await apiCall.get(controller, method);
      response.data = apiResponse?.data;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  },
  fetchRolesBySystemCode: async (system_code) => {
    let response = { success: true };
    const method = `authorized-roles/${system_code}`;
  
    try {
      const apiResponse = await apiCall.get(controller, method);
      response.data = apiResponse?.data;
    } catch (error) {
      response = apiCall.handleCatch(error);
    }
    return response;
  }, 
};
